




































import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { ColumnCount, Cell, MergeValues, EBlockWidth } from '@getaccept/editor-lib';
import { RowType } from '@getaccept/editor-lib';
import type { Comment } from '@getaccept/lib-shared/src/contextual-commenting/types/comment';
import { CreateContextualCommentButtonState } from '@getaccept/lib-shared/src/contextual-commenting/types/create-contextual-comment-button-state';
import { CommentsHelper } from '@getaccept/lib-shared/src/contextual-commenting/helpers/comments.helper';
import DetachedCommentAnchor from '@getaccept/lib-shared/src/contextual-commenting/components/DetachedCommentAnchor.vue';
import EditorCell from './EditorCell.vue';

export default defineComponent({
  name: 'EditorRowColumns',
  components: {
    DetachedCommentAnchor,
    EditorCell,
  },
  props: {
    columnCount: { type: Number as PropType<ColumnCount>, default: 3 },
    cells: { type: Array as PropType<Cell[]>, default: () => [] },
    mergeValues: {
      type: Object as PropType<MergeValues>,
      default: () => ({ document: {}, sender: {}, recipients: [], entity: {} }),
    },
    blockWidthClass: {
      type: String as PropType<EBlockWidth>,
      default: null,
    },
    pageWidth: { type: Number, default: 0 },
    isBlockToggled: { type: Boolean },
    isPdfViewer: { type: Boolean },
    comments: { type: Array as PropType<Comment[]>, default: () => [] },
    selectedCommentId: { type: String, default: '' },
    showContextualComments: { type: Boolean, default: false },
    createContextualCommentButtonState: {
      type: String as PropType<CreateContextualCommentButtonState>,
      default: CreateContextualCommentButtonState.Enabled,
    },
  },
  setup(props) {
    const cellWidth = computed(() => 100 / props.columnCount);

    const isParentFirstChild = (index: number) => index === 0;

    const isParentLastChild = (index: number) => index === props.cells.length - 1;

    const cellIds = computed(() => props.cells.map(({ id }) => id));

    const commentsWithoutCell = computed(() =>
      props.comments.filter(comment => !cellIds.value.includes(comment.editorSelection?.cellId))
    );

    return {
      commentsWithoutCell,
      RowType,
      cellWidth,
      isParentFirstChild,
      isParentLastChild,
      filterCommentsByCell: CommentsHelper.filterCommentsByCell,
    };
  },
});
